// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-gallery-icon {
  color: #fff;
  transition: all 0.3s ease-out;
  appearance: none;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
  position: absolute;
  z-index: 4;
  filter: drop-shadow(0 2px 2px rgb(25.5, 25.5, 25.5));
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-icon:hover {
    color: #337ab7;
  }
  .image-gallery-icon:hover .image-gallery-svg {
    transform: scale(1.1);
  }
}
.image-gallery-icon:focus {
  outline: 2px solid #337ab7;
}

.image-gallery-using-mouse .image-gallery-icon:focus {
  outline: none;
}

.image-gallery-fullscreen-button,
.image-gallery-play-button {
  bottom: 0;
  padding: 20px;
}
.image-gallery-fullscreen-button .image-gallery-svg,
.image-gallery-play-button .image-gallery-svg {
  height: 28px;
  width: 28px;
}
@media (max-width: 768px) {
  .image-gallery-fullscreen-button,
  .image-gallery-play-button {
    padding: 15px;
  }
  .image-gallery-fullscreen-button .image-gallery-svg,
  .image-gallery-play-button .image-gallery-svg {
    height: 24px;
    width: 24px;
  }
}
@media (max-width: 480px) {
  .image-gallery-fullscreen-button,
  .image-gallery-play-button {
    padding: 10px;
  }
  .image-gallery-fullscreen-button .image-gallery-svg,
  .image-gallery-play-button .image-gallery-svg {
    height: 16px;
    width: 16px;
  }
}

.image-gallery-fullscreen-button {
  right: 0;
}

.image-gallery-play-button {
  left: 0;
}

.image-gallery-left-nav,
.image-gallery-right-nav {
  padding: 50px 10px;
  top: 50%;
  transform: translateY(-50%);
}
.image-gallery-left-nav .image-gallery-svg,
.image-gallery-right-nav .image-gallery-svg {
  height: 120px;
  width: 60px;
}
@media (max-width: 768px) {
  .image-gallery-left-nav .image-gallery-svg,
  .image-gallery-right-nav .image-gallery-svg {
    height: 72px;
    width: 36px;
  }
}
@media (max-width: 480px) {
  .image-gallery-left-nav .image-gallery-svg,
  .image-gallery-right-nav .image-gallery-svg {
    height: 48px;
    width: 24px;
  }
}
.image-gallery-left-nav[disabled],
.image-gallery-right-nav[disabled] {
  cursor: disabled;
  opacity: 0.6;
  pointer-events: none;
}

.image-gallery-left-nav {
  left: 0;
}

.image-gallery-right-nav {
  right: 0;
}

.image-gallery {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: relative;
}
.image-gallery.fullscreen-modal {
  background: #000;
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 5;
}
.image-gallery.fullscreen-modal .image-gallery-content {
  top: 50%;
  transform: translateY(-50%);
}

.image-gallery-content {
  position: relative;
  line-height: 0;
  top: 0;
}
.image-gallery-content.fullscreen {
  background: #000;
}
.image-gallery-content .image-gallery-slide .image-gallery-image {
  max-height: calc(100vh - 80px);
}
.image-gallery-content.image-gallery-thumbnails-left .image-gallery-slide .image-gallery-image, .image-gallery-content.image-gallery-thumbnails-right .image-gallery-slide .image-gallery-image {
  max-height: 100vh;
}

.image-gallery-slide-wrapper {
  position: relative;
}
.image-gallery-slide-wrapper.image-gallery-thumbnails-left, .image-gallery-slide-wrapper.image-gallery-thumbnails-right {
  display: inline-block;
  width: calc(100% - 110px);
}
@media (max-width: 768px) {
  .image-gallery-slide-wrapper.image-gallery-thumbnails-left, .image-gallery-slide-wrapper.image-gallery-thumbnails-right {
    width: calc(100% - 87px);
  }
}
.image-gallery-slide-wrapper.image-gallery-rtl {
  direction: rtl;
}

.image-gallery-slides {
  line-height: 0;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  text-align: center;
}

.image-gallery-slide {
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.image-gallery-slide.image-gallery-center {
  position: relative;
}
.image-gallery-slide .image-gallery-image {
  width: 100%;
  object-fit: contain;
}
.image-gallery-slide .image-gallery-description {
  background: rgba(0, 0, 0, 0.4);
  bottom: 70px;
  color: #fff;
  left: 0;
  line-height: 1;
  padding: 10px 20px;
  position: absolute;
  white-space: normal;
}
@media (max-width: 768px) {
  .image-gallery-slide .image-gallery-description {
    bottom: 45px;
    font-size: 0.8em;
    padding: 8px 15px;
  }
}

.image-gallery-bullets {
  bottom: 20px;
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  width: 80%;
  z-index: 4;
}
.image-gallery-bullets .image-gallery-bullets-container {
  margin: 0;
  padding: 0;
  text-align: center;
}
.image-gallery-bullets .image-gallery-bullet {
  appearance: none;
  background-color: transparent;
  border: 1px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 2px rgb(25.5, 25.5, 25.5);
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
  outline: none;
  padding: 5px;
  transition: all 0.2s ease-out;
}
@media (max-width: 768px) {
  .image-gallery-bullets .image-gallery-bullet {
    margin: 0 3px;
    padding: 3px;
  }
}
@media (max-width: 480px) {
  .image-gallery-bullets .image-gallery-bullet {
    padding: 2.7px;
  }
}
.image-gallery-bullets .image-gallery-bullet:focus {
  transform: scale(1.2);
  background: #337ab7;
  border: 1px solid #337ab7;
}
.image-gallery-bullets .image-gallery-bullet.active {
  transform: scale(1.2);
  border: 1px solid #fff;
  background: #fff;
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-bullets .image-gallery-bullet:hover {
    background: #337ab7;
    border: 1px solid #337ab7;
  }
  .image-gallery-bullets .image-gallery-bullet.active:hover {
    background: #337ab7;
  }
}

.image-gallery-thumbnails-wrapper {
  position: relative;
}
.image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
  touch-action: pan-y;
}
.image-gallery-thumbnails-wrapper.thumbnails-swipe-vertical {
  touch-action: pan-x;
}
.image-gallery-thumbnails-wrapper.thumbnails-wrapper-rtl {
  direction: rtl;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
  display: inline-block;
  vertical-align: top;
  width: 100px;
}
@media (max-width: 768px) {
  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
    width: 81px;
  }
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails {
  height: 100%;
  width: 100%;
  left: 0;
  padding: 0;
  position: absolute;
  top: 0;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail {
  display: block;
  margin-right: 0;
  padding: 0;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail {
  margin-left: 0;
  margin-top: 2px;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
  margin: 0 5px;
}
@media (max-width: 768px) {
  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
    margin: 0 3px;
  }
}

.image-gallery-thumbnails {
  overflow: hidden;
  padding: 5px 0;
}
@media (max-width: 768px) {
  .image-gallery-thumbnails {
    padding: 3px 0;
  }
}
.image-gallery-thumbnails .image-gallery-thumbnails-container {
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.image-gallery-thumbnail {
  display: inline-block;
  border: 4px solid transparent;
  transition: border 0.3s ease-out;
  width: 100px;
  background: transparent;
  padding: 0;
}
@media (max-width: 768px) {
  .image-gallery-thumbnail {
    border: 3px solid transparent;
    width: 81px;
  }
}
.image-gallery-thumbnail + .image-gallery-thumbnail {
  margin-left: 2px;
}
.image-gallery-thumbnail .image-gallery-thumbnail-inner {
  display: block;
  position: relative;
}
.image-gallery-thumbnail .image-gallery-thumbnail-image {
  vertical-align: middle;
  width: 100%;
  line-height: 0;
}
.image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
  outline: none;
  border: 4px solid #337ab7;
}
@media (max-width: 768px) {
  .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
    border: 3px solid #337ab7;
  }
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-thumbnail:hover {
    outline: none;
    border: 4px solid #337ab7;
  }
}
@media (hover: hover) and (pointer: fine) and (max-width: 768px) {
  .image-gallery-thumbnail:hover {
    border: 3px solid #337ab7;
  }
}

.image-gallery-thumbnail-label {
  box-sizing: border-box;
  color: white;
  font-size: 1em;
  left: 0;
  line-height: 1em;
  padding: 5%;
  position: absolute;
  top: 50%;
  text-shadow: 0 2px 2px rgb(25.5, 25.5, 25.5);
  transform: translateY(-50%);
  white-space: normal;
  width: 100%;
}
@media (max-width: 768px) {
  .image-gallery-thumbnail-label {
    font-size: 0.8em;
    line-height: 0.8em;
  }
}

.image-gallery-index {
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  line-height: 1;
  padding: 10px 20px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 4;
}
@media (max-width: 768px) {
  .image-gallery-index {
    font-size: 0.8em;
    padding: 5px 10px;
  }
}

.perxis-auto-1_16_13-gallery {
  /* Image styles */
  --perxis-auto-gallery-image-border-radius-inner: var(--perxis-auto-gallery-image-border-radius, 18px);
  --perxis-auto-gallery-image-border-width-inner: var(--perxis-auto-gallery-image-border-width, 1px);
  --perxis-auto-gallery-image-border-color-inner: var(
    --perxis-auto-gallery-image-border-color,
    var(--perxis-auto-root-ninth-color-inner)
  );
  --perxis-auto-gallery-image-border-style-inner: var(--perxis-auto-gallery-image-border-style, solid);
  /* End Image styles */
  /* Thumbnail styles */
  --perxis-auto-gallery-thumbnail-border-width-inner: var(--perxis-auto-gallery-thumbnail-border-width, 1px);
  --perxis-auto-gallery-thumbnail-border-style-inner: var(--perxis-auto-gallery-thumbnail-border-style, solid);
  --perxis-auto-gallery-thumbnail-border-color-inner: var(
    --perxis-auto-gallery-thumbnail-border-color,
    var(--perxis-auto-root-ninth-color-inner)
  );
  --perxis-auto-gallery-thumbnail-border-radius-inner: var(--perxis-auto-gallery-thumbnail-border-radius, 8px);
  --perxis-auto-gallery-thumbnail-active-border-width-inner: var(
    --perxis-auto-gallery-thumbnail-active-border-width,
    4px
  );
  --perxis-auto-gallery-thumbnail-active-border-style-inner: var(
    --perxis-auto-gallery-thumbnail-active-border-style,
    solid
  );
  --perxis-auto-gallery-thumbnail-active-border-color-inner: var(
    --perxis-auto-gallery-thumbnail-active-border-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-gallery-thumbnail-active-border-radius-inner: var(
    --perxis-auto-gallery-thumbnail-active-border-radius,
    8px
  );
  /* End Thumbnail styles */
  /* Video Button styles */
  --perxis-auto-gallery-video-play-button-width-inner: var(--perxis-auto-gallery-video-play-button-width, 56px);
  --perxis-auto-gallery-video-play-button-height-inner: var(--perxis-auto-gallery-video-play-button-height, 40px);
  --perxis-auto-gallery-video-play-button-background-color-inner: var(
    --perxis-auto-gallery-video-play-button-background-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-gallery-video-play-button-icon-color-inner: var(
    --perxis-auto-gallery-video-play-button-icon-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-gallery-video-play-button-hover-icon-color-inner: var(
    --perxis-auto-gallery-video-play-button-hover-icon-color,
    var(--perxis-auto-gallery-video-play-button-icon-color-inner)
  );
  --perxis-auto-gallery-video-play-button-border-radius-inner: var(
    --perxis-auto-gallery-video-play-button-border-radius,
    8px
  );
  --perxis-auto-gallery-video-play-button-hover-background-color-inner: var(
    --perxis-auto-gallery-video-play-button-hover-background-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-gallery-video-play-button-opacity-inner: var(--perxis-auto-gallery-video-play-button-opacity, 1);
  --perxis-auto-gallery-video-play-button-hover-opacity-inner: var(
    --perxis-auto-gallery-video-play-button-hover-opacity-inner,
    1
  );
  --perxis-auto-gallery-thumbnail-video-play-button-width-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-width,
    40px
  );
  --perxis-auto-gallery-thumbnail-video-play-button-height-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-height,
    28px
  );
  --perxis-auto-gallery-thumbnail-video-play-button-background-color-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-background-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-gallery-thumbnail-video-play-button-icon-color-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-icon-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-gallery-thumbnail-video-play-button-hover-icon-color-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-hover-icon-color,
    var(--perxis-auto-gallery-thumbnail-video-play-button-icon-color-inner)
  );
  --perxis-auto-gallery-thumbnail-video-play-button-border-radius-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-border-radius,
    4px
  );
  --perxis-auto-gallery-thumbnail-video-play-button-hover-background-color-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-hover-background-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-gallery-thumbnail-video-play-button-opacity-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-opacity,
    1
  );
  --perxis-auto-gallery-thumbnail-video-play-button-hover-opacity-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-hover-opacity-inner,
    1
  );
  /* End Video Button styles */
  /* Navigation buttons styles */
  --perxis-auto-gallery-nav-button-icon-color-inner: var(
    --perxis-auto-gallery-nav-button-icon-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-gallery-nav-button-icon-hover-color-inner: var(
    --perxis-auto-gallery-nav-button-icon-hover-color,
    var(--perxis-auto-gallery-nav-button-icon-color-inner)
  );
  --perxis-auto-gallery-nav-button-opacity-inner: var(--perxis-auto-gallery-nav-button-opacity, 0.5);
  --perxis-auto-gallery-nav-button-hover-opacity-inner: var(--perxis-auto-gallery-nav-button-hover-opacity, 1);
  --perxis-auto-gallery-nav-button-padding-inner: var(--perxis-auto-gallery-nav-button-padding, 8px);
  /* End Navigation buttons styles */
  /* Fullscreen button styles */
  --perxis-auto-gallery-fullscreen-button-icon-color-inner: var(
    --perxis-auto-gallery-fullscreen-button-icon-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-gallery-fullscreen-button-icon-hover-color-inner: var(
    --perxis-auto-gallery-fullscreen-button-icon-hover-color,
    var(--perxis-auto-gallery-nav-button-icon-color-inner)
  );
  --perxis-auto-gallery-fullscreen-button-opacity-inner: var(--perxis-auto-gallery-fullscreen-button-opacity, 0.5);
  --perxis-auto-gallery-fullscreen-button-hover-opacity-inner: var(
    --perxis-auto-gallery-fullscreen-button-hover-opacity,
    1
  );
  --perxis-auto-gallery-fullscreen-button-padding-inner: var(--perxis-auto-gallery-fullscreen-button-padding, 0);
  /* End Fullscreen button styles */
  /* Play button styles */
  --perxis-auto-gallery-play-button-icon-color-inner: var(
    --perxis-auto-gallery-play-button-icon-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-gallery-play-button-icon-hover-color-inner: var(
    --perxis-auto-gallery-play-button-icon-hover-color,
    var(--perxis-auto-gallery-nav-button-icon-color-inner)
  );
  --perxis-auto-gallery-play-button-opacity-inner: var(--perxis-auto-gallery-play-button-opacity, 0.5);
  --perxis-auto-gallery-play-button-hover-opacity-inner: var(--perxis-auto-gallery-play-button-hover-opacity, 1);
  --perxis-auto-gallery-play-button-padding-inner: var(--perxis-auto-gallery-play-button-padding, 0);
  /* End Play button styles */
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-slide-wrapper {
  border-radius: var(--perxis-auto-gallery-image-border-radius-inner);
  border-width: var(--perxis-auto-gallery-image-border-width-inner);
  border-color: var(--perxis-auto-gallery-image-border-color-inner);
  border-style: var(--perxis-auto-gallery-image-border-style-inner);
  overflow: hidden;
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-right {
  transform: translate3d(101%, 0px, 0px) !important;
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-left {
  transform: translate3d(-101%, 0px, 0px) !important;
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnails {
  padding: 0;
  margin-top: 24px;
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnails {
    margin-top: 20px;
  }
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__nav-button {
  position: absolute;
  padding: var(--perxis-auto-gallery-nav-button-padding-inner);
  border: 0;
  outline: none;
  z-index: 1;
  background-color: transparent;
  color: var(--perxis-auto-gallery-nav-button-icon-color-inner);
  opacity: var(--perxis-auto-gallery-nav-button-opacity-inner);
  transition: opacity 0.3s, visibility 0s linear 0.3s;
  cursor: pointer;
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__nav-button.perxis-auto-1_16_13-gallery__nav-button-left {
  transform: translate(0%, -50%);
  top: 50%;
  left: 0;
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__nav-button.perxis-auto-1_16_13-gallery__nav-button-right {
  transform: translate(0%, -50%);
  top: 50%;
  right: 0;
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__nav-button:hover {
  color: var(--perxis-auto-gallery-nav-button-icon-hover-color-inner);
  opacity: var(--perxis-auto-gallery-nav-button-hover-opacity-inner);
}
@media (min-width: 0px) and (max-width: 767px) {
  .perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__nav-button.perxis-auto-1_16_13-gallery__nav-button-left, .perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__nav-button.perxis-auto-1_16_13-gallery__nav-button-right {
    display: none;
  }
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__fullscreen {
  position: absolute;
  background-color: transparent;
  padding: var(--perxis-auto-gallery-fullscreen-button-padding-inner);
  border: 0;
  outline: none;
  z-index: 1;
  color: var(--perxis-auto-gallery-fullscreen-button-icon-color-inner);
  opacity: var(--perxis-auto-gallery-fullscreen-button-opacity-inner);
  transition: opacity 0.3s, visibility 0s linear 0.3s;
  cursor: pointer;
  transform: translate(-50%, -50%);
  bottom: 0;
  right: 0;
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__fullscreen:hover {
  color: var(--perxis-auto-gallery-fullscreen-button-icon-hover-color-inner);
  opacity: var(--perxis-auto-gallery-fullscreen-button-hover-opacity-inner);
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery-video__play {
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--perxis-auto-gallery-video-play-button-width-inner);
  height: var(--perxis-auto-gallery-video-play-button-height-inner);
  opacity: var(--perxis-auto-gallery-video-play-button-opacity-inner);
  position: absolute;
  border: 0;
  cursor: pointer;
  outline: none;
  border-radius: var(--perxis-auto-gallery-video-play-button-border-radius-inner);
  background-color: var(--perxis-auto-gallery-video-play-button-background-color-inner);
  color: var(--perxis-auto-gallery-video-play-button-icon-color-inner);
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery-video__play:hover {
  background-color: var(--perxis-auto-gallery-video-play-button-hover-background-color-inner);
  opacity: var(--perxis-auto-gallery-video-play-button-hover-opacity-inner);
  color: var(--perxis-auto-gallery-video-play-button-hover-icon-color-inner);
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery-video-wrapper iframe {
  aspect-ratio: 16/9;
  width: 100%;
  border: none;
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery-thumbnail-video__play {
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--perxis-auto-gallery-thumbnail-video-play-button-width-inner);
  height: var(--perxis-auto-gallery-thumbnail-video-play-button-height-inner);
  opacity: var(--perxis-auto-gallery-thumbnail-video-play-button-opacity-inner);
  position: absolute;
  border: 0;
  outline: none;
  border-radius: var(--perxis-auto-gallery-thumbnail-video-play-button-border-radius-inner);
  background-color: var(--perxis-auto-gallery-thumbnail-video-play-button-background-color-inner);
  color: var(--perxis-auto-gallery-thumbnail-video-play-button-icon-color-inner);
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__play {
  position: absolute;
  background-color: transparent;
  padding: var(--perxis-auto-gallery-play-button-padding-inner);
  border: 0;
  outline: none;
  z-index: 1;
  color: var(--perxis-auto-gallery-play-button-icon-color-inner);
  opacity: var(--perxis-auto-gallery-play-button-opacity-inner);
  transition: opacity 0.3s, visibility 0s linear 0.3s;
  cursor: pointer;
  transform: translate(50%, -50%);
  bottom: 0;
  left: 0;
}
.perxis-auto-1_16_13-gallery .image-gallery .perxis-auto-1_16_13-gallery__play:hover {
  color: var(--perxis-auto-gallery-play-button-icon-hover-color-inner);
  opacity: var(--perxis-auto-gallery-play-button-hover-opacity-inner);
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail {
  position: relative;
  overflow: hidden;
  box-sizing: content-box;
  border: none;
  width: 62px;
  height: 42px;
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail {
    width: 103px;
    height: 69px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail {
    width: 136px;
    height: 92px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail {
    width: 94px;
    height: 62px;
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail {
    width: 117px;
    height: 78px;
  }
}
@media (min-width: 1600px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail {
    width: 153px;
    height: 102px;
  }
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail:hover {
  --perxis-auto-gallery-thumbnail-video-play-button-icon-color-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-hover-icon-color-inner
  );
  --perxis-auto-gallery-thumbnail-video-play-button-background-color-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-hover-background-color-inner
  );
  --perxis-auto-gallery-thumbnail-video-play-button-opacity-inner: var(
    --perxis-auto-gallery-thumbnail-video-play-button-hover-opacity-inner
  );
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail .image-gallery-thumbnail-inner {
  height: 100%;
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail::after {
  content: " ";
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-width: var(--perxis-auto-gallery-thumbnail-border-width-inner);
  border-style: var(--perxis-auto-gallery-thumbnail-border-style-inner);
  border-color: var(--perxis-auto-gallery-thumbnail-border-color-inner);
  border-radius: var(--perxis-auto-gallery-thumbnail-border-radius-inner);
  cursor: pointer;
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail + .image-gallery-thumbnail {
  margin-left: 12px;
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail + .image-gallery-thumbnail {
    margin-left: 18px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail + .image-gallery-thumbnail {
    margin-left: 22px;
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail + .image-gallery-thumbnail {
    margin-left: 14px;
  }
}
@media (min-width: 1600px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail + .image-gallery-thumbnail {
    margin-left: 17px;
  }
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail.active::after {
  border-width: var(--perxis-auto-gallery-thumbnail-active-border-width-inner);
  border-style: var(--perxis-auto-gallery-thumbnail-active-border-style-inner);
  border-color: var(--perxis-auto-gallery-thumbnail-active-border-color-inner);
  border-radius: var(--perxis-auto-gallery-thumbnail-active-border-radius-inner);
}
.perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail-image {
  border-radius: var(--perxis-auto-gallery-thumbnail-border-radius-inner);
  max-height: calc(42px - var(--perxis-auto-gallery-image-border-width-inner) * 2);
  vertical-align: baseline;
  object-fit: cover;
  overflow-clip-margin: unset;
  height: 100%;
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail-image {
    max-height: calc(69px - var(--perxis-auto-gallery-image-border-width-inner) * 2);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail-image {
    max-height: calc(92px - var(--perxis-auto-gallery-image-border-width-inner) * 2);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail-image {
    max-height: calc(62px - var(--perxis-auto-gallery-image-border-width-inner) * 2);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail-image {
    max-height: calc(78px - var(--perxis-auto-gallery-image-border-width-inner) * 2);
  }
}
@media (min-width: 1600px) {
  .perxis-auto-1_16_13-gallery .image-gallery .image-gallery-thumbnail-image {
    max-height: calc(102px - var(--perxis-auto-gallery-image-border-width-inner) * 2);
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
